import LocaleService from '@services/LocaleService';

const i18n = LocaleService.getTranslations('general.navMenus');

const navMenus = {
  dentist: [
    {
      title: i18n.home,
      to: '/',
      key: '/',
    },
    {
      title: i18n.referrals,
      to: '/referrals/all',
      key: '/referrals',
    },
    {
      title: i18n.labOrders,
      to: '/lab-orders/pending',
      key: '/lab-orders',
    },
    {
      title: i18n.dentists,
      to: '/dentists',
      key: '/dentists',
    },
    {
      title: i18n.clinics,
      to: '/clinics',
      key: '/clinics',
    },
    {
      title: i18n.labs,
      to: '/labs',
      key: '/labs',
    },
    {
      title: i18n.communityBoard,
      to: '/community-board',
      key: '/community-board',
    },
  ],
  'dental-clinic': [
    {
      title: i18n.home,
      to: '/',
      key: '/',
    },
    {
      title: i18n.referrals,
      to: '/referrals/all',
      key: '/referrals',
    },
    {
      title: i18n.labOrders,
      to: '/lab-orders/pending',
      key: '/lab-orders',
    },
    {
      title: i18n.dentists,
      to: '/dentists',
      key: '/dentists',
    },
    {
      title: i18n.clinics,
      to: '/clinics',
      key: '/clinics',
    },
    {
      title: i18n.labs,
      to: '/labs',
      key: '/labs',
    },
  ],
  laboratory: [
    {
      title: i18n.home,
      to: '/',
      key: '/',
    },
    {
      title: i18n.labOrders,
      to: '/lab-orders/pending',
      key: '/lab-orders',
    },
  ],
};
export default navMenus;
